const toPercentage = value => value * 100;

export const peergroupComparisonParser = data =>
  data.map(
    ({
      variable,
      value,
      peergroupScoreWorst,
      peergroupScoreAvg,
      peergroupScoreBest,
      peergroupImpactAvg,
      peergroupImpactBest,
      peergroupImpactWorst,
      companyImpact,
      supplyChainImpact,
    }) => ({
      title: variable,
      score: parseFloat(value?.toFixed(1)),
      worstScore: parseFloat(peergroupScoreWorst.toFixed(1)),
      averageScore: parseFloat(peergroupScoreAvg.toFixed(1)),
      bestScore: parseFloat(peergroupScoreBest.toFixed(1)),
      companyImpact: toPercentage(companyImpact).toFixed(1),
      supplyChainImpact: toPercentage(supplyChainImpact).toFixed(1),
      averageImpact: toPercentage(peergroupImpactAvg),
      bestImpact: toPercentage(peergroupImpactBest),
      worstImpact: toPercentage(peergroupImpactWorst),
    }),
  );
